import { Button, Result } from 'antd';
import {useTranslation} from "react-i18next";

const SuccessOrder = () => {

    const { t } = useTranslation();

    return (
        <Result
            status="success"
            title={t("successfullyPurchased")}
            subTitle={t("successfullyPurchasedSubTitle")}
            extra={[
                <Button
                    color="default"
                    variant="solid"
                    type="primary"
                    key="home"
                    onClick={() => window.location.href = '/'}>
                    {t("backToHome")}
                </Button>,
            ]}
        />
    );
};

export default SuccessOrder;